(function () {
    'use strict';

    angular
        .module('assets.mybimiboo.com')
        .controller('CategoriesCtrl', CategoriesCtrl);

    function CategoriesCtrl($scope, $state, $stateParams, $location, $http, AuthenticationService, _env) {

        $scope.numeral = numeral;
        $scope.auth = AuthenticationService;

        $scope.curTab = 'equipments';

        getEquipmentCategories();

        function getEquipmentCategories() {
            $http.get(_env.apiUrl + '/equipment-categories').then(function (response) {
                $scope.equipmentCategories = response.data;
            });
        }

        $scope.editEquipmentCategory = function(equipmentCategory) {
            if (equipmentCategory) {
                $scope.equipmentCategory = angular.copy(equipmentCategory);
            } else {
                $scope.equipmentCategory = {}
            }

            $('#modal-equipment-category').modal('show');
        }

        $scope.saveEquipmentCategory = function () {
            if (!$scope.equipmentCategory) return;

            if (!$scope.equipmentCategory.title) {
                error('Title is required');
                return;
            }

            var data = {
                title: $scope.equipmentCategory.title,
                order: $scope.equipmentCategory.id ? $scope.equipmentCategory.order : $scope.equipmentCategories.length
            };

            $scope.proccessing = true;

            if ($scope.equipmentCategory.id) {
                $http.put(_env.apiUrl + '/equipment-categories/' + $scope.equipmentCategory.id, data).then(function(response) {
                    $('#modal-equipment-category').modal('hide');
                    getEquipmentCategories();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/equipment-categories', data).then(function(response) {
                    $('#modal-equipment-category').modal('hide');
                    getEquipmentCategories();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteEquipmentCategory = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/equipment-categories/' + $scope.equipmentCategory.id).then(function () {
                        $('#modal-equipment-category').modal('hide');
                        getEquipmentCategories();
                        Swal.fire({
                            type: 'success',
                            title: 'Equipment category successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        // locations

        function getLocations() {
            $http.get(_env.apiUrl + '/locations').then(function (response) {
                $scope.locations = response.data;
            });
        }

        getLocations();

        $scope.editLocation = function(location) {
            if (location) {
                $scope.location = angular.copy(location);
            } else {
                $scope.location = {}
            }

            $('#modal-location').modal('show');
        }

        $scope.saveLocation = function () {
            if (!$scope.location) return;

            if (!$scope.location.title) {
                error('Title is required');
                return;
            }

            var data = {
                title: $scope.location.title
            };

            $scope.proccessing = true;

            if ($scope.location.id) {
                $http.put(_env.apiUrl + '/locations/' + $scope.location.id, data).then(function(response) {
                    $('#modal-location').modal('hide');
                    getLocations();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/locations', data).then(function(response) {
                    $('#modal-location').modal('hide');
                    getLocations();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteLocation = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/locations/' + $scope.location.id).then(function () {
                        $('#modal-location').modal('hide');
                        getLocations();
                        Swal.fire({
                            type: 'success',
                            title: 'Location successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        // intellectual-property

        function getIntellectualPropertyCategories() {
            $http.get(_env.apiUrl + '/trademark-categories').then(function (response) {
                $scope.intellectualPropertyCategories = response.data;
            });
        }

        getIntellectualPropertyCategories();

        $scope.editIntellectualPropertyCategory = function(intellectualPropertyCategory) {
            if (intellectualPropertyCategory) {
                $scope.intellectualPropertyCategory = angular.copy(intellectualPropertyCategory);
            } else {
                $scope.intellectualPropertyCategory = {}
            }

            $('#modal-intellectual-property-category').modal('show');
        }

        $scope.saveIntellectualPropertyCategory = function () {
            if (!$scope.intellectualPropertyCategory) return;

            if (!$scope.intellectualPropertyCategory.title) {
                error('Title is required');
                return;
            }

            var data = {
                title: $scope.intellectualPropertyCategory.title,
                order: $scope.intellectualPropertyCategory.id ? $scope.intellectualPropertyCategory.order : $scope.intellectualPropertyCategories.length
            };

            $scope.proccessing = true;

            if ($scope.intellectualPropertyCategory.id) {
                $http.put(_env.apiUrl + '/trademark-categories/' + $scope.intellectualPropertyCategory.id, data).then(function(response) {
                    $('#modal-intellectual-property-category').modal('hide');
                    getIntellectualPropertyCategories();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/trademark-categories', data).then(function(response) {
                    $('#modal-intellectual-property-category').modal('hide');
                    getIntellectualPropertyCategories();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteIntellectualPropertyCategory = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/trademark-categories/' + $scope.intellectualPropertyCategory.id).then(function () {
                        $('#modal-intellectual-property-category').modal('hide');
                        getIntellectualPropertyCategories();
                        Swal.fire({
                            type: 'success',
                            title: 'Intellectual Property Category successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        // library

        function getLibraryItemCategories() {
            $http.get(_env.apiUrl + '/library-item-categories').then(function (response) {
                $scope.libraryItemCategories = response.data;
            });
        }

        getLibraryItemCategories();

        $scope.editLibraryItemCategory = function(libraryItemCategory) {
            if (libraryItemCategory) {
                $scope.libraryItemCategory = angular.copy(libraryItemCategory);
            } else {
                $scope.libraryItemCategory = {}
            }

            $('#modal-library-item-category').modal('show');
        }

        $scope.saveLibraryItemCategory = function () {
            if (!$scope.libraryItemCategory) return;

            if (!$scope.libraryItemCategory.title) {
                error('Title is required');
                return;
            }

            var data = {
                title: $scope.libraryItemCategory.title,
                order: $scope.libraryItemCategory.id ? $scope.libraryItemCategory.order : $scope.libraryItemCategories.length
            };

            $scope.proccessing = true;

            if ($scope.libraryItemCategory.id) {
                $http.put(_env.apiUrl + '/library-item-categories/' + $scope.libraryItemCategory.id, data).then(function(response) {
                    $('#modal-library-item-category').modal('hide');
                    getLibraryItemCategories();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/library-item-categories', data).then(function(response) {
                    $('#modal-library-item-category').modal('hide');
                    getLibraryItemCategories();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteLibraryItemCategory = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/library-item-categories/' + $scope.libraryItemCategory.id).then(function () {
                        $('#modal-library-item-category').modal('hide');
                        getLibraryItemCategories();
                        Swal.fire({
                            type: 'success',
                            title: 'Category successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        function getLibraryItemLanguages() {
            $http.get(_env.apiUrl + '/library-item-languages').then(function (response) {
                $scope.libraryItemLanguages = response.data;
            });
        }

        getLibraryItemLanguages();

        $scope.editLibraryItemLanguage = function(libraryItemLanguage) {
            if (libraryItemLanguage) {
                $scope.libraryItemLanguage = angular.copy(libraryItemLanguage);
            } else {
                $scope.libraryItemLanguage = {}
            }

            $('#modal-library-item-language').modal('show');
        }

        $scope.saveLibraryItemLanguage = function () {
            if (!$scope.libraryItemLanguage) return;

            if (!$scope.libraryItemLanguage.title) {
                error('Title is required');
                return;
            }

            var data = {
                title: $scope.libraryItemLanguage.title
            };

            $scope.proccessing = true;

            if ($scope.libraryItemLanguage.id) {
                $http.put(_env.apiUrl + '/library-item-languages/' + $scope.libraryItemLanguage.id, data).then(function(response) {
                    $('#modal-library-item-language').modal('hide');
                    getLibraryItemLanguages();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/library-item-languages', data).then(function(response) {
                    $('#modal-library-item-language').modal('hide');
                    getLibraryItemLanguages();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteLibraryItemLanguage = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/library-item-languages/' + $scope.libraryItemLanguage.id).then(function () {
                        $('#modal-library-item-language').modal('hide');
                        getLibraryItemCategories();
                        Swal.fire({
                            type: 'success',
                            title: 'Language successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }
    }
})();